import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
} from "@angular/core";
import {
  VAIconRegistryService,
  exclamationTriangle,
} from "@va/core-library/icons";
import { AppService } from "src/app/app.service";

@Component({
  selector: "app-create-new-charts-naming",
  templateUrl: "./create-new-charts-naming.component.html",
  styleUrls: ["./create-new-charts-naming.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CreateNewChartsNamingComponent implements OnInit {
  @Input() companyData;
  @Input() liData;
  @Input() type;
  @Input() yearTypeData;
  @Input() revision;
  @Input() createPeriod;
  @Input() filterData;
  @Output() saveChartsName = new EventEmitter();
  @Output() saveRevision = new EventEmitter();
  @Output() saveYearType = new EventEmitter();
  @Output() saveEstimate = new EventEmitter();
  @ViewChild("name") nameField: ElementRef;
  summaryData: any;
  companySummaryData: Array<string> = [];
  liSummaryData: Array<string> = [];
  chartNameError = "";
  ChartName = "";
  period = "";
  tickers: Array<string> = [];
  periodsWithAvailableData;

  revisionPeriodList = [
    { label: "3 months", value: "3m" },
    { label: "6 months", value: "6m" },
    { label: "12 months", value: "12m" },
  ];

  constructor(
    private appService: AppService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([exclamationTriangle]);
  }

  ngOnInit() {
    const year = this.createPeriod.map((p) => p.split("-")[1]);
    this.period = year.toString();
    for (let i = 0; i < this.companyData.length; i++) {
      this.tickers.push(this.companyData[i].ticker);
      const data = `${this.companyData[i].ticker} - ${this.companyData[i].name}`;
      this.companySummaryData.push(data);
    }
    for (let i = 0; i < this.liData.length; i++) {
      const data = `${this.liData[i].name}`;
      this.liSummaryData.push(data);
    }
    this.summaryData = [
      { title: "Companies", data: this.companySummaryData },
      {
        title: "Line Items",
        data: this.liSummaryData,
      },
    ];
    this.getPeriodsWithAvailableData(this.tickers);
  }

  ngAfterViewInit() {
    this.nameField.nativeElement.focus();
  }

  onChangeChartName() {
    if (this.ChartName === "") {
      this.chartNameError = "Chart Name cannot be blank.";
    } else {
      this.chartNameError = "";
    }
    this.saveChartsName.emit(this.ChartName);
  }

  setCreateChartPeriod(period) {
    this.createPeriod = [...period];
    const year = period.map((p) => {
      const period = p.split("-");
      return `${period[1]}`;
    });
    this.period = year.toString();
    this.liSummaryData = [];
    for (let i = 0; i < this.liData.length; i++) {
      const data = `${this.liData[i].name}`;
      this.liSummaryData.push(data);
    }
    this.summaryData = [
      { title: "Companies", data: this.companySummaryData },
      {
        title: "Line Items",
        data: this.liSummaryData,
      },
    ];
    this.saveEstimate.emit(period);
  }

  saveRevisionPeriod(revision) {
    this.saveRevision.emit(revision);
  }

  saveChartsYearType(params) {
    this.saveYearType.emit(params);
  }

  getPeriodsWithAvailableData(tickerIds) {
    this.appService
      .getPeriodsWithData(tickerIds)
      .subscribe((response: { status; dataAvailable }) => {
        if (response.status === "success") {
          this.periodsWithAvailableData = response.dataAvailable;
        }
      });
  }
}
